module.exports = __webpack_public_path__ + "img/blog7.b0c39346.jpeg";